/*
 * Copyright (c) CIRROM 2025.
 */

import React from "react";
import WorkIcon from "@mui/icons-material/Work";
import {
  getJobTitleChangesForProjectOrSystem,
  MonitorJobTitleChange,
} from "../../api/cirrommonitor";
import {
  RecentMoversPanel,
  RecentMoversPanelConfig,
} from "./RecentMoversPanel";

const config: RecentMoversPanelConfig<MonitorJobTitleChange> = {
  title: "Recent Job Title Changes",
  subheader: "Contacts who recently changed job titles",
  emptyMessage: "No recent job title changes detected",
  icon: WorkIcon,
  avatarColor: "info.main",
  trendingColor: "info",
  fetchFunction: getJobTitleChangesForProjectOrSystem,
  getOldValue: (item) => item.old_job_title,
  getNewValue: (item) => item.new_job_title,
  seeMoreTab: "job_title",
};

export const JobTitleChangesPanel: React.FC<{
  isDataProject: boolean;
  dataProjectId: number;
  integratedSystemId: number;
}> = ({ isDataProject, dataProjectId, integratedSystemId }) => {
  return (
    <RecentMoversPanel
      isDataProject={isDataProject}
      dataProjectId={dataProjectId}
      integratedSystemId={integratedSystemId}
      config={config}
    />
  );
};
